import * as React from 'react'
import IconType from './iconType'

const ExternalRefIcon = (props: IconType) => {

  return (
    <svg
      className={`${props.className}`}
      height={props.h}
      width={props.w}
      viewBox="0 0 640 512"
      >
      <path d="M.0003 185.8C.0003 179.4 1.606 173.1 4.67 167.4L82.36 25.02C90.77 9.595 106.9 0 124.5 0H515.5C533.1 0 549.2 9.595 557.6 25.02L635.3 167.4C638.4 173.1 640 179.4 640 185.8C640 206.9 622.9 224 601.8 224H576V488C576 501.3 565.3 512 552 512C538.7 512 528 501.3 528 488V224H384V472C384 494.1 366.1 512 344 512H103.1C81.91 512 63.1 494.1 63.1 472V224H38.25C17.12 224 0 206.9 0 185.8H.0003zM111.1 224V320H336V224H111.1zM124.5 48L54.68 176H585.3L515.5 48H124.5zM336 464V368H111.1V464H336z"
      />
    </svg>
  )
}

export default ExternalRefIcon
